import TriMoji from "./TriMoji";

const Oops = TriMoji({ top: "🤲", mid: "⛈️", bottom: "🥵" });

export default Oops;
